import Integration from "components/integration/Integration";

export default function IntegrationTab() {
    return (
        <div>
            <Integration />
        </div>
    );
}